<template>
  <path
    d="M9.29006 15.8802L13.1701 12.0002L9.29006 8.12016C8.90006 7.73016 8.90006 7.10016 9.29006 6.71016C9.68006 6.32016 10.3101 6.32016 10.7001 6.71016L15.2901 11.3002C15.6801 11.6902 15.6801 12.3202 15.2901 12.7102L10.7001 17.3002C10.3101 17.6902 9.68006 17.6902 9.29006 17.3002C8.91006 16.9102 8.90006 16.2702 9.29006 15.8802Z"
  />
</template>
